import {createReducer} from "typesafe-actions";
import { CategoriesArray } from "../../../models/api/codegen/code";
import { CATEGORIES } from "../actions";

export const categories = createReducer([] as CategoriesArray[])
    .handleAction(CATEGORIES, (state, action: { payload : CategoriesArray[] }) : CategoriesArray[] => action.payload);